import { render, staticRenderFns } from "./DataConvert.vue?vue&type=template&id=06e9d606&"
import script from "./DataConvert.vue?vue&type=script&lang=js&"
export * from "./DataConvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports